import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from 'src/app/service/util.service';


@Component({
  selector: 'demo-dm-maturity',
  templateUrl: './demo-dm-maturity.html'
})
export class DemoDmMaturity implements OnInit {
  preQualObj: any;

  constructor(private utilService: UtilService, private router: Router, private _activatedRoute: ActivatedRoute) {
    this.utilService.isSidebarVisible.next(false);
  }

  ngOnInit(): void {
  }
  dmResponse(status) {
    if (status === 'failed') {
      this.router.navigate(['../request-callback'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    } else {
      this.router.navigate(['../your-online-exclusive-rate-offers'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
    }
  }

}


